<template>
  <div class="body-find" @keydown.esc.stop.prevent="close">
    <div v-if="opened" class="body-find-bar" role="search" aria-label="기사 본문 찾기">
      <label>본문 찾기 <input ref="input" v-model="query" aria-label="본문 검색어" @keydown.enter.prevent="move($event.shiftKey ? -1 : 1)"></label>
      <span aria-live="polite">{{ matches.length ? current + 1 : 0 }} / {{ matches.length }}</span>
      <button type="button" :disabled="!matches.length" @click="move(-1)">이전</button>
      <button type="button" :disabled="!matches.length" @click="move(1)">다음</button>
      <button type="button" @click="close">닫기</button>
    </div>
    <div ref="marks" class="body-find-marks" aria-hidden="true">
      <i v-for="(rect, index) in rectangles" :key="index" :class="{ active: rect.active }" :style="rect.style"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: { getEditor: { type: Function, required: true } },
  data: () => ({ opened: false, query: '', matches: [], current: 0, rectangles: [] }),
  watch: { query() { this.search(true); } },
  mounted() {
    this.editor = this.getEditor();
    document.body.appendChild(this.$refs.marks);
    this.keyHandler = event => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'f') {
        event.preventDefault(); this.open();
      }
    };
    this.changeHandler = () => { if (this.opened) this.search(false); };
    this.scrollHandler = () => {
      if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.paint(); });
    };
    this.editor.root.addEventListener('keydown', this.keyHandler);
    this.editor.on('text-change', this.changeHandler);
    window.addEventListener('scroll', this.scrollHandler, true);
    window.addEventListener('resize', this.scrollHandler);
  },
  beforeDestroy() {
    this.editor.root.removeEventListener('keydown', this.keyHandler);
    this.editor.off('text-change', this.changeHandler);
    window.removeEventListener('scroll', this.scrollHandler, true);
    window.removeEventListener('resize', this.scrollHandler);
    cancelAnimationFrame(this.frame);
    this.$refs.marks.remove();
  },
  methods: {
    open() {
      this.opened = true;
      const selection = this.editor.getSelection();
      if (selection && selection.length) this.query = this.editor.getText(selection.index, selection.length);
      this.search(false);
      this.$nextTick(() => { this.$refs.input.focus(); this.$refs.input.select(); });
    },
    close() { this.opened = false; this.rectangles = []; this.editor.focus(); },
    search(jump) {
      // Use Quill offsets, including embedded images, without modifying the Delta/HTML.
      let text = '';
      this.editor.getContents().ops.forEach(op => { text += typeof op.insert === 'string' ? op.insert : '\uFFFC'; });
      this.matches = [];
      if (this.query) {
        let at = 0;
        while ((at = text.indexOf(this.query, at)) !== -1) {
          this.matches.push(at); at += this.query.length;
        }
      }
      this.current = Math.min(this.current, Math.max(0, this.matches.length - 1));
      if (jump) { this.current = 0; this.reveal(); }
      this.$nextTick(this.paint);
    },
    move(step) {
      if (!this.matches.length) return;
      this.current = (this.current + step + this.matches.length) % this.matches.length;
      this.reveal(); this.paint();
    },
    reveal() {
      if (!this.matches.length) return;
      const bounds = this.editor.getBounds(this.matches[this.current], this.query.length);
      if (bounds) this.editor.scrollRectIntoView(bounds);
    },
    paint() {
      if (!this.opened || !this.query) { this.rectangles = []; return; }
      const editorRect = this.editor.root.getBoundingClientRect();
      const rects = [];
      this.matches.forEach((index, match) => {
        const [start, offset] = this.editor.getLeaf(index);
        const [end, endOffset] = this.editor.getLeaf(index + this.query.length);
        if (!start || !end || start.domNode.nodeType !== 3 || end.domNode.nodeType !== 3) return;
        const range = document.createRange();
        range.setStart(start.domNode, offset); range.setEnd(end.domNode, endOffset);
        Array.from(range.getClientRects()).forEach(rect => {
          const left = Math.max(0, editorRect.left, rect.left), top = Math.max(0, editorRect.top, rect.top);
          const right = Math.min(innerWidth, editorRect.right, rect.right), bottom = Math.min(innerHeight, editorRect.bottom, rect.bottom);
          if (right > left && bottom > top) rects.push({ active: match === this.current,
            style: { left: left + 'px', top: top + 'px', width: (right - left) + 'px', height: (bottom - top) + 'px' } });
        });
      });
      this.rectangles = rects;
    }
  }
};
</script>
<style scoped>
.body-find{max-width:calc(100vw - 20px)}
.body-find-bar{display:flex;align-items:center;flex-wrap:wrap;gap:8px;padding:10px;background:#f6f7f9;border:1px solid #ccc;font-size:13px;color:#333}
.body-find-bar input{border:1px solid #aaa;border-radius:3px;padding:5px;width:180px;max-width:100%;background:white;color:#222}
.body-find-bar button{padding:5px 9px;border:1px solid #bbb;border-radius:3px;background:white;cursor:pointer}.body-find-bar button:disabled{opacity:.45}
.body-find-marks{position:fixed;inset:0;pointer-events:none;z-index:9999}.body-find-marks i{position:absolute;background:rgba(255,220,0,.3)}.body-find-marks i.active{background:rgba(255,150,0,.35);outline:2px solid #dc7a00}
</style>
